export default __webpack_public_path__ + "static/media/noPatient.8b5517b1.png";